import { getDefaultClassNames } from 'react-day-picker';

const defaults = getDefaultClassNames();

/**
 * Tailwind class names for the Calendar component, mapped from the old
 * tremor-calendar.css overrides to our custom design tokens.
 *
 * Old tremor CSS mapping reference:
 *
 * | Tremor override                          | Tailwind equivalent                                           |
 * |------------------------------------------|---------------------------------------------------------------|
 * | .bg-dark-tremor-background               | bg-surface-primary (on Calendar root)                         |
 * | .border-dark-tremor-border → border-0    | border-0 (not needed, no border on Calendar)                  |
 * | tremor-calendar-button border-0 font-bk  | button_previous/button_next: border-0                         |
 * | nav SVG text-secondary                   | chevron: text-secondary                                       |
 * | tremor-title-font font-black             | month_caption: font-black text-headline-s text-primary        |
 * | caption p text-headline-s! text-primary! | caption_label: text-headline-s text-primary                   |
 * | cell-hover fill-dark text-negative       | day_button: hover:fill-dark hover:text-negative               |
 * | selected-button fill-dark text-negative  | selected: fill-dark text-negative                             |
 * | selected-range fill-tertiary             | range_middle: fill-tertiary text-primary                      |
 * | dark range_middle bg-neutral-60          | range_middle: dark:bg-neutral-60                              |
 * | dark selected text-neutral-0             | range_start/range_end: dark:text-neutral-0                    |
 * | outside text-tertiary (was .text-subtle) | outside: text-tertiary                                        |
 * | disabled .text-tertiary cursor-no        | disabled: text-tertiary opacity-50 cursor-not-allowed         |
 * | shadow-calendar on popup                 | Applied on PopoverPanel in DatePicker/DateRangePicker          |
 */
export const CALENDAR_CLASS_NAMES = {
  // Layout
  root: `${defaults.root} p-3 rounded-lg`,
  months: defaults.months,
  month: defaults.month,
  month_grid: defaults.month_grid,

  // Caption / header
  month_caption: `${defaults.month_caption} text-headline-s text-primary font-black`,
  caption_label: `${defaults.caption_label} text-headline-s text-primary`,

  // Navigation arrows
  nav: defaults.nav,
  button_previous: `${defaults.button_previous} border-0`,
  button_next: `${defaults.button_next} border-0`,
  chevron: 'text-secondary fill-current',

  // Weekday headers
  weekdays: `${defaults.weekdays} text-tertiary text-link-regular-xs`,
  weekday: defaults.weekday,

  // Week rows
  weeks: defaults.weeks,
  week: defaults.week,

  // Day cells
  day: `${defaults.day} text-body-m`,
  day_button: `${defaults.day_button} rounded-md text-secondary outline-none hover:fill-dark hover:text-negative`,

  // Selection states
  selected: `${defaults.selected} fill-dark text-negative rounded-md`,
  today: `${defaults.today} font-bold`,
  outside: `${defaults.outside} text-tertiary`,
  disabled: `${defaults.disabled} text-tertiary opacity-50 cursor-not-allowed`,

  // Range states — only start/end get rounding, middle days are flat
  range_start: `${defaults.range_start} fill-dark text-negative rounded-l-md rounded-r-none dark:text-neutral-0`,
  range_end: `${defaults.range_end} fill-dark text-negative rounded-r-md rounded-l-none dark:text-neutral-0`,
  range_middle: `${defaults.range_middle} fill-tertiary text-primary rounded-none dark:bg-neutral-60`,

  hidden: defaults.hidden,
} as const;
